var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { HotAreaEventListenerTypes, generateHandlers, EventEmitTypes, events, emitHotArea, generateHotareaActionParams, getHotAreaId, withPersistReactEvent, deleteHotAreaNode, setHotAreaNode, } from '@tencent/gems-shared';
var LONG_PRESS_TIMEOUT = 1000;
var DOUBLE_CLICK_TIMEOUT = 200;
var INTERSECTION_TIMEOUT = 500;
var HotAreaActionHandler = /** @class */ (function (_super) {
    __extends(HotAreaActionHandler, _super);
    function HotAreaActionHandler(props) {
        var _this = _super.call(this, props) || this;
        _this.intersectionObserver = null;
        _this.handlerParams = {};
        _this.handlers = {};
        _this.containerRef = null;
        _this.longPressTimer = null;
        _this.preventClick = false;
        _this.doubleClickTimer = null;
        _this.intersectionTimer = null;
        _this.execActionHooks = function (actions) {
            actions.forEach(function (action) {
                if (typeof action.action.action === 'function') {
                    return;
                }
                var hooks = action.action.action;
                if (hooks.afterHandlerRender) {
                    var params = generateHotareaActionParams(action, _this.props.hotArea, _this.props.instance, _this.props.global, _this.props.meta);
                    try {
                        hooks.afterHandlerRender(params);
                    }
                    catch (e) {
                        console.error('Action "afterHandlerRender" hook throw error: ', e);
                    }
                }
            });
        };
        _this.initIntersectionObserver = function () {
            _this.intersectionObserver = new window.IntersectionObserver(function (entries) {
                entries.forEach(function (_a) {
                    var target = _a.target, isIntersecting = _a.isIntersecting;
                    var key = parseInt(target.getAttribute('data-key'), 10);
                    events.emit(EventEmitTypes.HOT_AREA_INTERSECTING_CHANGE, isIntersecting, key);
                });
            });
        };
        _this.observeIntersection = function () { return _this.intersectionObserver.observe(_this.containerRef); };
        _this.unobserveIntersection = function () { return _this.intersectionObserver.unobserve(_this.containerRef); };
        _this.onHotAreaIntersectionChange = function (isIntersecting, key) {
            if (key !== _this.props.hotArea.key) {
                return;
            }
            if (_this.intersectionTimer) {
                clearTimeout(_this.intersectionTimer);
                _this.intersectionTimer = null;
            }
            var callback = isIntersecting ? _this.onHotAreaEnterView : _this.onHotAreaLeaveView;
            _this.intersectionTimer = window.setTimeout(function () {
                callback();
                clearTimeout(_this.intersectionTimer);
                _this.intersectionTimer = null;
            }, INTERSECTION_TIMEOUT);
        };
        _this.onHotAreaEnterView = function () {
            if (_this.handlers.onEnterView) {
                _this.handlers.onEnterView(undefined);
            }
        };
        _this.onHotAreaLeaveView = function () {
            if (_this.handlers.onLeaveView) {
                _this.handlers.onLeaveView(undefined);
            }
        };
        _this.onHotAreaPress = withPersistReactEvent(function (e) {
            if (!_this.handlers.onLongPress) {
                return;
            }
            _this.longPressTimer = window.setTimeout(function () { return _this.handlers.onLongPress(e); }, LONG_PRESS_TIMEOUT);
        });
        _this.onHotAreaPressRelease = function () {
            if (_this.longPressTimer) {
                window.clearTimeout(_this.longPressTimer);
            }
            _this.longPressTimer = null;
        };
        _this.onMouseEnter = withPersistReactEvent(function () {
            _this.handlers.onMouseEnter();
        });
        _this.onMouseLeave = withPersistReactEvent(function () {
            _this.handlers.onMouseLeave();
        });
        _this.onSingleClick = withPersistReactEvent(function (e) {
            _this.doubleClickTimer = window.setTimeout(function () {
                if (!_this.preventClick) {
                    try {
                        _this.handlers.onClick(e);
                    }
                    catch (e) {
                        console.error('Exec onClick action error:', e);
                    }
                }
            }, DOUBLE_CLICK_TIMEOUT);
        });
        _this.onDoubleClick = withPersistReactEvent(function (e) {
            if (_this.doubleClickTimer) {
                clearTimeout(_this.doubleClickTimer);
                _this.doubleClickTimer = null;
            }
            _this.preventClick = true;
            try {
                _this.handlers.onDoubleClick(e);
            }
            catch (e) {
                console.error('Exec onClick action error:', e);
            }
            setTimeout(function () {
                _this.preventClick = false;
            }, DOUBLE_CLICK_TIMEOUT);
        });
        _this.emitHotAreaEvent = function (e, type) {
            var _a = _this, _b = _a.props, hotArea = _b.hotArea, instance = _b.instance, _c = _a.handlerParams, global = _c.global, meta = _c.meta;
            return emitHotArea(e, type, hotArea, instance, meta, global);
        };
        _this.withEmitHotAreaEvent = function (type, handler) { return function (e) {
            if (e) {
                e.persist();
            }
            _this.emitHotAreaEvent(e, type);
            if (handler) {
                return handler(e, _this.handlerParams);
            }
        }; };
        _this.updateHandlerParams = function (meta, global) {
            _this.handlerParams.meta = meta;
            _this.handlerParams.global = global;
        };
        _this.updateHandlersWithParams = function (actions) {
            var _a = generateHandlers(actions, _this.props.instance, _this.props.hotArea), onInit = _a.onInit, onClick = _a.onClick, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, onDoubleClick = _a.onDoubleClick, onLongPress = _a.onLongPress, onEnterView = _a.onEnterView, onLeaveView = _a.onLeaveView;
            var _b = _this, withEmitHotAreaEvent = _b.withEmitHotAreaEvent, handlers = _b.handlers;
            handlers.onInit = withEmitHotAreaEvent(HotAreaEventListenerTypes.INIT, onInit);
            handlers.onClick = withEmitHotAreaEvent(HotAreaEventListenerTypes.CLICK, onClick);
            handlers.onMouseEnter = withEmitHotAreaEvent(HotAreaEventListenerTypes.MOUSE_ENTER, onMouseEnter);
            handlers.onMouseLeave = withEmitHotAreaEvent(HotAreaEventListenerTypes.MOUSE_LEAVE, onMouseLeave);
            handlers.onDoubleClick = withEmitHotAreaEvent(HotAreaEventListenerTypes.DOUBLE_CLICK, onDoubleClick);
            handlers.onLongPress = withEmitHotAreaEvent(HotAreaEventListenerTypes.LONG_PRESS, onLongPress);
            handlers.onEnterView = withEmitHotAreaEvent(HotAreaEventListenerTypes.ENTER_VIEW, onEnterView);
            handlers.onLeaveView = withEmitHotAreaEvent(HotAreaEventListenerTypes.LEAVE_VIEW, onLeaveView);
        };
        _this.setNode = function (node) {
            _this.containerRef = node;
            setHotAreaNode(node);
        };
        _this.handlerParams = { global: props.global, meta: props.meta };
        _this.updateHandlersWithParams(props.hotArea.actions);
        return _this;
    }
    HotAreaActionHandler.prototype.componentDidMount = function () {
        if (!process.env.isMiniprogram) {
            this.initIntersectionObserver();
            this.observeIntersection();
        }
        events.on(EventEmitTypes.HOT_AREA_INTERSECTING_CHANGE, this.onHotAreaIntersectionChange);
        if (this.handlers.onInit) {
            this.handlers.onInit(undefined);
        }
        this.execActionHooks(this.props.hotArea.actions);
    };
    HotAreaActionHandler.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        if (nextProps.global !== this.props.global || nextProps.meta !== this.props.meta) {
            this.updateHandlerParams(nextProps.meta, nextProps.global);
        }
        if (nextProps.hotArea.actions !== this.props.hotArea.actions) {
            this.updateHandlersWithParams(nextProps.hotArea.actions);
        }
    };
    HotAreaActionHandler.prototype.componentWillUnmount = function () {
        if (!process.env.isMiniprogram) {
            this.unobserveIntersection();
        }
        events.cancel(EventEmitTypes.HOT_AREA_INTERSECTING_CHANGE, this.onHotAreaIntersectionChange);
        deleteHotAreaNode(this.props.hotArea.kebabCase);
        if (this.longPressTimer) {
            window.clearTimeout(this.longPressTimer);
        }
    };
    HotAreaActionHandler.prototype.render = function () {
        var _a;
        var _b = this.props, children = _b.children, _c = _b.style, style = _c === void 0 ? {} : _c;
        var elementType = process.env.isMiniprogram ? 'wx-button' : 'div';
        // wx-button 视为 Web Components, 故使用 class, 见 https://reactjs.org/docs/dom-elements.html#classname
        var classKey = process.env.isMiniprogram ? 'class' : 'className';
        return React.createElement(elementType, (_a = {},
            _a[classKey] = '__impage-hot-area-actions-proxy',
            _a.id = getHotAreaId(this.props.hotArea.key),
            _a.ref = this.setNode,
            _a['data-key'] = this.props.hotArea.key,
            _a.onClick = this.onSingleClick,
            _a.onDoubleClick = this.onDoubleClick,
            _a.onMouseEnter = this.onMouseEnter,
            _a.onMouseLeave = this.onMouseLeave,
            _a.onTouchStart = this.onHotAreaPress,
            _a.onTouchEnd = this.onHotAreaPressRelease,
            _a.onMouseDown = this.onHotAreaPress,
            _a.onMouseUp = this.onHotAreaPressRelease,
            _a.style = style,
            _a), children);
    };
    return HotAreaActionHandler;
}(React.PureComponent));
export { HotAreaActionHandler };
//# sourceMappingURL=HotAreaActionHandler.js.map